import type { EndorsementOption } from '@/api/types/enrollment'

type EndorsementDetailsModalProps = {
  endorsement: EndorsementOption | null
  isSelected: boolean
  onClose: () => void
  onToggle: (value: string) => void
}

export function EndorsementDetailsModal({
  endorsement,
  isSelected,
  onClose,
  onToggle
}: EndorsementDetailsModalProps) {
  if (!endorsement) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" />
      <div className="relative w-full max-w-[360px] rounded-2xl border-2 border-gray-lighter bg-white px-5 py-4 shadow-[0_10px_24px_rgba(0,0,0,0.14)]">
        <h3 className="text-center text-sm font-bold uppercase tracking-wide text-gray-dark">
          Endorsement Details
        </h3>
        <div className="mt-4 space-y-2 text-xs leading-5 text-[#1f1f1f] md:text-[13px] md:leading-6">
          <p>
            <span className="font-bold">CDL Endorsement:</span>{' '}
            {endorsement.label || endorsement.type}
          </p>
          {endorsement.code ? (
            <p>
              <span className="mt-2 font-bold">Code:</span> {endorsement.code}
            </p>
          ) : null}
          {endorsement.description ? (
            <p>
              <span className="mt-2 font-bold">Description:</span> {endorsement.description}
            </p>
          ) : null}
          {endorsement.requirements ? (
            <p>
              <span className="mt-2 font-bold">Requirements:</span> {endorsement.requirements}
            </p>
          ) : null}
        </div>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 items-center justify-center rounded-[50px] border border-gray-300 bg-white px-4 py-0 text-sm font-medium text-gray-700 transition-all duration-150 hover:bg-gray-100"
          >
            Back
          </button>
          <button
            type="button"
            onClick={() => {
              onToggle(endorsement.type)
              onClose()
            }}
            className="flex h-9 items-center justify-center rounded-[50px] bg-primary px-4 py-0 text-sm font-medium text-white transition-all duration-150 hover:bg-primary/90"
          >
            {isSelected ? 'Remove Endorsement' : 'Add Endorsement'}
          </button>
        </div>
      </div>
    </div>
  )
}
